<template>
  <v-card>
    <v-card-title>
      <span class="headline">Agregar horas</span>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" class="font-weight-bold">
          Agregue un rango de horas
        </v-col>
        <v-col cols="6">
          <v-dialog
            ref="dialog1"
            v-model="modal1"
            :return-value.sync="time1"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="time1"
                label="Hora de inicio"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="modal1"
              v-model="time1"
              full-width
              format="24hr"
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modal1 = false">
                Cancelar
              </v-btn>
              <v-btn text color="primary" @click="$refs.dialog1.save(time1)">
                OK
              </v-btn>
            </v-time-picker>
          </v-dialog>
        </v-col>
        <v-col cols="6">
          <v-dialog
            ref="dialog2"
            v-model="modal2"
            :return-value.sync="time2"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="time2"
                label="Hora final"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="modal2"
              v-model="time2"
              full-width
              format="24hr"
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modal2 = false">
                Cancelar
              </v-btn>
              <v-btn text color="primary" @click="$refs.dialog2.save(time2)">
                OK
              </v-btn>
            </v-time-picker>
          </v-dialog>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn color="gray darken-1" @click="$emit('close', true)">
        Cancelar
      </v-btn>
      <v-btn v-if="button_active" color="blue darken-1" class="white--text" @click="agregarHoras">
        Guardar
      </v-btn>
      <v-btn
        v-if="!button_active"
        color="blue darken-1"
        class="white--text"
        disabled
      >
          Cargando...
      </v-btn>
    </v-card-actions>
  </v-card>
</template>


<script>
import axios from "axios";

export default {
  name: "FormDiaAtencion",
  props: ["horario"],
  data() {
    return {
      time1: this.horario ? this.horario.hora_inicio : null,
      time2: this.horario ? this.horario.hora_fin : null,
      modal1: false,
      modal2: false,
      button_active: true
    };
  },
  methods: {
    agregarHoras() {
      if(this.time1 == null && this.time2 == null){
        this.$emit("snackbar", true);

        return
      }
      this.button_active = false
      axios
        .post("/api/horario-atencion", {
          hora_inicio: this.time1,
          hora_fin: this.time2,
          horario: this.horario
        })
        .then(() => {
          this.button_active = true
          this.$emit("close", true);
          this.$emit("listar");
        })
        .catch((error) => {
          this.$emit("close", true);
          window.console.log(error);
        });
    },
  },
};
</script>

<style scoped>
</style>
